/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=9a1e52e8&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9a1e52e8&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=9a1e52e8&lang=css"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈工程-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a1e52e8"]])

export default __exports__